import { m as lazyMotion } from 'motion/react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import { makeStyles } from 'tss-react/mui';

import { variants } from './variants.ts';

const useStyles = makeStyles()(({ palette, spacing, typography }) => ({
  bubbleContainer: {
    display: 'flex',
    alignSelf: 'flex-start',
    justifyContent: 'center',
    backgroundColor: palette.chat.bubble.scoopr.background,
    padding: spacing(2),
    borderRadius: 8,
    boxShadow: '0px 1px 3px rgba(24, 160, 251, 0.12)',
    marginBottom: spacing(2.5),
  },
  bubbleContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    ...typography.p1,
    color: palette.chat.bubble.scoopr.text,

    paddingRight: spacing(1),
    maxHeight: '35vh',
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': {
      width: 3,
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: 3,
      backgroundColor: 'rgba(0,0,0,.25)',
    },

    '& > p': {
      margin: 0,
    },
    '& > h3': {
      marginTop: 0,
    },
    '& a': {
      color: palette.primary.main,
      textDecoration: 'none',
      '&:hover': {
        cursor: 'pointer',
        textDecoration: 'underline',
      },
    },
    '& ul': {
      marginTop: spacing(1),
      paddingLeft: spacing(3),
    },
    '& li': {
      margin: spacing(0.5, 0),
    },
    '& > :last-child': {
      marginBottom: 0,
    },
  },
}));

interface ScooprBubbleProps {
  utterance: string;
  classes?: any;
}

const ScooprBubble = ({ utterance, classes: parentClasses }: ScooprBubbleProps) => {
  const { classes } = useStyles(undefined, {
    props: {
      classes: parentClasses,
    },
  });

  return (
    <lazyMotion.div className={classes.bubbleContainer} variants={variants}>
      <div className={classes.bubbleContent}>
        <ReactMarkdown rehypePlugins={[rehypeRaw]}>{utterance}</ReactMarkdown>
      </div>
    </lazyMotion.div>
  );
};

export default ScooprBubble;
